import styled from "styled-components";
import { NumberDataPoint } from "../analyticsTypes";
import { ResponsiveContainer } from "recharts";

interface TimeToFirstTradeDisplayProps {
  data: NumberDataPoint;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const ValueContainer = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: 10px;
`;

const Value = styled.span`
  font-size: 3rem;
  font-weight: 700;
  color: #002035;
`;

const Unit = styled.span`
  font-size: 1.5rem;
  font-weight: 500;
  color: #4a6271;
  margin-left: 10px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export const TimeToFirstTradeDisplay = ({ data }: TimeToFirstTradeDisplayProps) => {
  const formattedValue = data.data;

  return (
    <ResponsiveContainer id="time-to-first-trade-chart" height="80%" width="95%">
      <ContentWrapper>
        <Container>
          <ValueContainer>
            <Value>{formattedValue}</Value>
            <Unit>days</Unit>
          </ValueContainer>
        </Container>
      </ContentWrapper>
    </ResponsiveContainer>
  );
};
